import { Typography } from "@mui/material"
import React from "react"
export const PanelVisits = (): JSX.Element => {
    return (
        <Typography variant="h5" color="secondary.main">
            Visitas
        </Typography>
    )
}